//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import sharedMethods from "../sharedMethods";

export default {
  computed: mapGetters(["getApi", "getHost"]),
  data() {
    return {
      pwLost: false,
      username: "",
      vorname: "",
      password: "",
      repeatPassword: "",
      newPassword: "",
      msg: "",
      resetMsg: "",
      requestTokenMsg: "",
      showResetForm: false,
      showPwChangeSuccess: false,
      mail: "",
      resetToken: null,
      changePwButtonDisabled: true,
      emailSentMsg: "",
      loggedIn: false,
      register: false,
      passwordRepeat: "",
      surname: "",
      firstName: "",
      organisation: "",
      telephone: "",
    };
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("/dashboard").catch((err) => {
        console.log(err);
      });
    }
    if ("" + this.$route.query.token != "undefined") {
      this.showResetForm = true;
      this.pwLost = false;
      this.resetToken = this.$route.query.token;
    } else {
      this.showResetForm = false;
    }
  },
  computed: {
    isNewPwValid() {
      return this.newPassword.length >= 6 || this.newPassword.length == 0;
    },
  },

  methods: {
    ...mapActions(["resetUserPassword"]),
    wait(ms) {
      var start = new Date().getTime();
      var end = start;
      while (end < start + ms) {
        end = new Date().getTime();
      }
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    requestPwResetToken() {
      console.log("request token");
      if (!this.mail.includes("@")) {
        this.requestTokenMsg = "Please enter a valid Mail";
      } else {
        this.requestTokenMsg = "";

        const requestBody = {
          email: this.mail,
        };
        console.log("CALLING VUEX TO REQUEST RESET LINK");
        this.resetUserPassword(requestBody).then((resp) => {
          if (resp.data.status == 200) {
            this.emailSentMsg = "Please check your inbox";
          }
        });
      }
    },

    setNewPassword() {
      this.emailSentMsg = "";
      console.log("CALL SET NEW PW FUNC");
      if (this.newPassword.length < 6) {
        this.resetMsg = "Minimum password length is 6";
      } else if (this.newPassword != this.repeatPassword) {
        this.resetMsg = "Passwords do not match";
      } else {
        this.resetMsg = "";

        const requestBody = {
          id: this.$store.getters.getUser.id,
          token: this.resetToken,
          password: this.newPassword,
          password_repeat: this.repeatPassword,
        };

        this.resetUserPassword(requestBody).then((resp) => {
          if (resp.data.status == 200) {
            this.resetToken = "";
            this.showPwChangeSuccess = true;
            /* $(".check-icon").hide(); */

            setTimeout(() => {
              console.log("TIMEOUT EXCEEDED");
              this.showPwChangeSuccess = false;
              this.showResetForm = false;
            }, 3300);
          }
        });
      }
    },

    async signUp() {
      const credentials = {
        email: this.mail,
        username: this.username,
        password: this.password,
        password_repeat: this.passwordRepeat,
        firstname: this.firstName,
        lastname: this.surname,
        organisation: this.organisation,
        phone: this.telephone,
      };

      this.$store.dispatch("signUp", credentials).then((msg) => {
        this.msg = msg;

        if (!msg.msg && !msg.msg.includes("New account successfully registerd.")) {
          sharedMethods.errorNotify(msg.msg);
        } else {
          this.image = this.getHost + "/content/" + this.accID + "/thumb/profile.png";
          this.vorname = this.$store.getters.getUser.Vorname;

          // log the user in
          setTimeout(() => {
            this.login();
          });
        }
      });
    },

    async login() {
      const credentials = {
        username: this.username,
        password: this.password,
      };

      this.$store
        .dispatch("login", credentials)
        .then((msg) => {
          this.msg = msg;

          if (msg === "logged in") {
            this.image = this.getHost + "/content/" + this.accID + "/thumb/profile.png";
            this.vorname = this.$store.getters.getUser.Vorname ? this.$store.getters.getUser.Vorname : "have a nice day!";
            this.loggedIn = true;

            setTimeout(() => {
              this.$router.push("/dashboard").catch((err) => {
                console.log(err);
              });
            }, 2000);
          }
        })
        .catch((error) => {
          if (error == "Error: Request failed with status code 401" || error == "Error: Request failed with status code 404") {
            this.msg = "Wrong User or Password";
            sharedMethods.errorNotify("Wrong User or Password");
          } else {
            this.msg = error;
            sharedMethods.errorNotify(error);
          }
        });
    },
  },
};
